"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewTabLinkButton = void 0;
var newTabLinkButton_1 = require("./newTabLinkButton");
Object.defineProperty(exports, "NewTabLinkButton", { enumerable: true, get: function () { return __importDefault(newTabLinkButton_1).default; } });
